import * as React from "react";
import {cx} from "emotion";

import "./sample-mailing-card.scss";

import {
    getSampleMailingCardError,
    isAddressEmpty
}                       from "@Common/logic/sample-mailing-card/get-sample-mailing-card-error";
import {cs}             from "@Common/react/chain-services";
import {AddressModalA}  from "@Common/ui-components/heavy/mailing-ui/ml-addresses-table/address-modal-a";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const SampleMailingCard = (
    {
        selected, address, onChangeAddress, disclaimer, eh, domRef,
        disablePrepopulateEditModal=false,
    }
) => cs(
    ({}) => (
        <div className="sample-mailing-card sample-mailing-card-6rk">
            <div className="header">
                <div className="left">
                    <div {...{
                        className: "title",
                        "xd-qa-type": "label",
                        "xd-qa-name": "Send Sample Card",
                    }}>
                        Send Sample Card
                    </div>
                    <div {...{
                        className: "sub-title",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Send Sample Card Description",
                    }}>
                        {selected.value ? (
                            "A sample card will be added to this order’s quantity and sent to the address below. Turn this option off to not send a sample card."
                        ) : (
                            "Turn this option on to send a sample card for this order to a selected address."
                        )}
                    </div>
                    {!!disclaimer && (
                        <div {...{
                            className: "disclaimer",
                            "xd-qa-type": "text",
                            "xd-qa-name": "Send Sample Card Disclaimer",
                        }}>
                            {disclaimer}
                        </div>
                    )}
                </div>

                <div className="right">
                    {SliderCheckbox(
                        {
                            ...selected,
                            xdQaName:'Sample Mailing Card Slider'
                        }
                    )}
                </div>
            </div>

            {selected.value && cs(
                ["modal", (_, next) => AddressModalA({
                    title: "Edit Sample Card Address",
                    alterFields: (fields) => fields.map((field) => (
                        field.path === "name" ? {
                            ...field,
                            required: true,
                        } : field.path === "name2" ? {
                            ...field,
                            label: "Company/Name 2",
                        } : (
                            field
                        )
                    )),
                    next,
                })],
                ({modal}) => Box({
                    address: address,
                    onEdit: ({actionName}) => {
                        modal.show({
                            actionName,
                            countryCode: "US",
                            onConfirm: async (edited) => {
                                await onChangeAddress(edited);
                            },
                            ...!disablePrepopulateEditModal && {
                                initData: address,
                            },
                        });
                    },

                    eh: eh,
                    domRef: domRef,
                })
            )}
        </div>
    ),
);

const Box = ({address, eh, domRef, onEdit}) => cs(
    () => (
        <div className="box">
            <div {...{
                className: "title",

                "xd-qa-type": "label",
                "xd-qa-name": "Sample Card Address",
            }}>
                Sample Card Address:
            </div>
            {!address ? (
                <div {...{
                    className: "loading",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Loading",
                }}>
                    Loading...
                </div>
            ) : !isAddressEmpty(address) && (
                <div className="address">
                    <div {...{
                        className: "name",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Address Name",
                    }}>
                        {address.name}
                    </div>
                    {!!address.name2 && (
                        <div {...{
                            className: "name2",
                            "xd-qa-type": "text",
                            "xd-qa-name": "Address Name 2",
                        }}>
                            {address.name2}
                        </div>
                    )}
                    <div {...{
                        className: "address",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Street Address",
                    }}>
                        {address.address}{address.address2 && `, ${address.address2}`}
                    </div>
                    <div {...{
                        className: "city-state-zip",
                        "xd-qa-type": "text",
                        "xd-qa-name": "City, State, Zip Code",
                    }}>
                        {address.city}, {address.state} {address.zip}
                    </div>
                </div>
            )}

            {cs(
                ({}, next) => address && next(),
                ["error", (_, next) => next(getSampleMailingCardError(address))],
                ({error}) => error && (
                    <div className={cx("error", eh.css)} ref={domRef}>
                        {error}
                    </div>
                )
            )}

            <div className="actions">
                <a {...{
                    onClick: () => onEdit({
                        actionName: isAddressEmpty(address) ? "add" : "edit",
                    }),
                    "xd-qa-type": "link",
                    "xd-qa-name": "Sample Mailing Card Edit",
                }}>
                    {isAddressEmpty(address) ? (
                        "Add"
                    ) : (
                        "Edit"
                    )}
                </a>
            </div>
        </div>
    ),
);
